// extracted by mini-css-extract-plugin
export default {"mainWindow":"styles_mainWindow__qHdC-","contentWindow":"styles_contentWindow__LuruA"};